import { j as p } from "../jsx-runtime-ClSzPYp4.js";
import { s as x } from "../index.esm-DOxVcNnO.js";
import { useState as g, Children as C, cloneElement as E, isValidElement as P } from "react";
import { styled as i } from "styled-components";
import { compose as j, flexbox as y, space as R } from "styled-system";
import $ from "../HelperText/HelperText.mjs";
import { noOp as b } from "../common/utils/index.mjs";
import F from "./Radio.mjs";
const G = /* @__PURE__ */ i($).withConfig({
  componentId: "sc-3c46fe91-0"
})([
  "",
  ""
], ({ theme: r }) => r.components.radioGroup.radioError), h = /* @__PURE__ */ i.fieldset.withConfig({
  shouldForwardProp: (r) => x(r)
}).withConfig({
  componentId: "sc-3c46fe91-1"
})([
  "",
  " ",
  ""
], ({ theme: r }) => r.components.radioGroup.fieldset, j(y, R)), T = ({ bordered: r = !1, children: n, defaultValue: a = "", error: s = !1, errorText: d = "Please select an answer", name: e, variant: m = "default", onCheck: f = b, optionWrapperProps: c = {}, ...l }) => {
  const [u, w] = g(a);
  return /* @__PURE__ */ p.jsxs(h, {
    "data-qa-id": `${e}-radio-group`,
    ...s ? {
      "aria-describedby": `${e}-error`
    } : {},
    ...l,
    onChange: (o) => {
      const { value: t } = o.target;
      w(t), f(t);
    },
    children: [
      C.map(n, (o) => {
        var t;
        return o && /* @__PURE__ */ P(o) && o.type === F ? /* @__PURE__ */ E(o, {
          name: e,
          defaultValue: a,
          bordered: r,
          error: s,
          checkedValue: u,
          variant: m,
          wrapperProps: {
            ...c,
            ...((t = o == null ? void 0 : o.props) == null ? void 0 : t.wrapperProps) || {}
          }
        }) : o;
      }),
      s && /* @__PURE__ */ p.jsx(G, {
        variant: "error",
        "data-qa-id": `${e}-error`,
        id: `${e}-error`,
        children: d
      })
    ]
  });
};
export {
  T as default
};
